var map = {
	"./google_workspace.svg": 5429,
	"./icons-dark/IDrive logo.png": 36831,
	"./icons-dark/google-workspace.png": 91042,
	"./icons-dark/google-workspace.svg": 10671,
	"./icons-dark/logo-color.svg": 12937,
	"./icons-disabled/icons-svg/activity-logs.svg": 77821,
	"./icons-disabled/icons-svg/admin.svg": 78738,
	"./icons-disabled/icons-svg/backup-now.svg": 82204,
	"./icons-disabled/icons-svg/close-icon.svg": 32838,
	"./icons-disabled/icons-svg/delete-icon.svg": 39779,
	"./icons-disabled/icons-svg/download.svg": 37886,
	"./icons-disabled/icons-svg/edit.svg": 66241,
	"./icons-disabled/icons-svg/overview.svg": 31933,
	"./icons-disabled/icons-svg/recovery-menu.svg": 35241,
	"./icons-disabled/icons-svg/recovery.svg": 38544,
	"./icons-disabled/icons-svg/refresh.svg": 94457,
	"./icons-disabled/icons-svg/responsive-restore-icon.svg": 66122,
	"./icons-disabled/icons-svg/responsive-search-icon.svg": 34254,
	"./icons-disabled/icons-svg/responsive-user-icon.svg": 54695,
	"./icons-disabled/icons-svg/search.svg": 23775,
	"./icons-disabled/icons-svg/seat-management.svg": 34568,
	"./icons-disabled/icons-svg/users.svg": 25695,
	"./icons-svg/Restore-icon.svg": 43266,
	"./icons-svg/activity-logs.svg": 38768,
	"./icons-svg/admin-red.svg": 71366,
	"./icons-svg/admin.svg": 93445,
	"./icons-svg/arrow_01.svg": 56161,
	"./icons-svg/arrow_02.svg": 71143,
	"./icons-svg/arrowscroll-hover.svg": 9145,
	"./icons-svg/arrowscroll.svg": 91742,
	"./icons-svg/backup-now.svg": 27357,
	"./icons-svg/business_backup.svg": 81510,
	"./icons-svg/calendar-table.svg": 31213,
	"./icons-svg/calendar.svg": 48441,
	"./icons-svg/calender-icon.svg": 5448,
	"./icons-svg/chat.svg": 48135,
	"./icons-svg/close-icon-dark.svg": 66370,
	"./icons-svg/close-icon.svg": 10290,
	"./icons-svg/contact-table.svg": 39826,
	"./icons-svg/contacts.svg": 66450,
	"./icons-svg/delete-icon.svg": 1430,
	"./icons-svg/down-arrow-white.svg": 22172,
	"./icons-svg/down-arrow.svg": 44177,
	"./icons-svg/download-lightgray.svg": 87171,
	"./icons-svg/download.svg": 94608,
	"./icons-svg/drives.svg": 20626,
	"./icons-svg/dropdown.svg": 90384,
	"./icons-svg/exchange-onselect.svg": 60803,
	"./icons-svg/exchange.svg": 60907,
	"./icons-svg/fail.svg": 74930,
	"./icons-svg/failuer-icon.svg": 59332,
	"./icons-svg/folder shortcut.svg": 18840,
	"./icons-svg/folder.svg": 73728,
	"./icons-svg/help icon.svg": 32184,
	"./icons-svg/info-lighten.svg": 27638,
	"./icons-svg/info-white.svg": 84660,
	"./icons-svg/info.svg": 42745,
	"./icons-svg/mail.svg": 6597,
	"./icons-svg/marketplace-icon.svg": 62722,
	"./icons-svg/na.svg": 51522,
	"./icons-svg/no-results-img.jpeg": 51371,
	"./icons-svg/onedrive-onselect.svg": 59731,
	"./icons-svg/onedrive.svg": 68291,
	"./icons-svg/overview-shared-mailboxes.svg": 83754,
	"./icons-svg/overview-sites.svg": 16562,
	"./icons-svg/overview-teams.svg": 67058,
	"./icons-svg/overview-total-seats-for-backup-365.svg": 31546,
	"./icons-svg/overview-total-seats-for-backup-google.svg": 35507,
	"./icons-svg/overview-user.svg": 29980,
	"./icons-svg/overview.svg": 26233,
	"./icons-svg/pending-icon.svg": 92891,
	"./icons-svg/personal_backup.svg": 53724,
	"./icons-svg/plus-icon.svg": 44974,
	"./icons-svg/protected-data.svg": 24734,
	"./icons-svg/recovery-menu.svg": 99770,
	"./icons-svg/recovery.svg": 26170,
	"./icons-svg/recurring_calendar.svg": 25994,
	"./icons-svg/refresh.svg": 26179,
	"./icons-svg/responsive-restore-icon.svg": 84588,
	"./icons-svg/responsive-search-icon.svg": 15160,
	"./icons-svg/responsive-user-icon.svg": 1341,
	"./icons-svg/right-arrow.svg": 87878,
	"./icons-svg/search.svg": 9790,
	"./icons-svg/seat-management.svg": 96507,
	"./icons-svg/shared-drives-icon.svg": 34361,
	"./icons-svg/shared-drives.svg": 7601,
	"./icons-svg/sharepoint-onselect.svg": 98142,
	"./icons-svg/sharepoint.svg": 40009,
	"./icons-svg/snapshort-icon.svg": 53689,
	"./icons-svg/sort-icon.svg": 17580,
	"./icons-svg/success-icon.svg": 85946,
	"./icons-svg/success.svg": 77150,
	"./icons-svg/sync-icon.svg": 37628,
	"./icons-svg/teams-onselect.svg": 36696,
	"./icons-svg/teams.svg": 5439,
	"./icons-svg/theme_dark.svg": 90938,
	"./icons-svg/theme_light.svg": 85626,
	"./icons-svg/tick-error-icon.svg": 45771,
	"./icons-svg/tick-icon.svg": 2607,
	"./icons-svg/tick.svg": 98710,
	"./icons-svg/up-arrow-white.svg": 73058,
	"./icons-svg/up-arrow.svg": 60826,
	"./icons-svg/users-1.svg": 71329,
	"./icons-svg/users-green.svg": 77069,
	"./icons-svg/users.svg": 48255,
	"./icons/administrators-color.svg": 53527,
	"./icons/administrators.svg": 51595,
	"./icons/arrow-caret-down.svg": 57629,
	"./icons/arrow-caret-right.svg": 70774,
	"./icons/arrow-down.svg": 49072,
	"./icons/arrow-up.svg": 48641,
	"./icons/avatar.svg": 84306,
	"./icons/backup-color.svg": 34127,
	"./icons/backup.svg": 34550,
	"./icons/caret-down.svg": 41237,
	"./icons/delete-bin-color.svg": 64354,
	"./icons/delete-bin.svg": 41206,
	"./icons/download-color.svg": 47615,
	"./icons/download.svg": 52219,
	"./icons/edit-color.svg": 68796,
	"./icons/edit.svg": 30140,
	"./icons/error.svg": 43646,
	"./icons/export-color.svg": 3083,
	"./icons/export.svg": 51327,
	"./icons/exports-color.svg": 57735,
	"./icons/exports.svg": 74880,
	"./icons/logout.svg": 4941,
	"./icons/overview-color.svg": 47961,
	"./icons/overview.svg": 44475,
	"./icons/question-mark.svg": 32671,
	"./icons/recovery-color.svg": 28004,
	"./icons/recovery.svg": 33596,
	"./icons/restore-color.svg": 15945,
	"./icons/restore.svg": 45538,
	"./icons/restores-color.svg": 6913,
	"./icons/restores.svg": 74201,
	"./icons/search-.svg": 35344,
	"./icons/search-color.svg": 55899,
	"./icons/search.svg": 40590,
	"./icons/seat-management-color.svg": 17313,
	"./icons/seat-management.svg": 2060,
	"./icons/users-color.svg": 44498,
	"./icons/users.svg": 3015,
	"./images/Gsuite-sprite-image-mail.svg": 69241,
	"./images/idrive-loader-dark.gif": 86252,
	"./images/idrive-loader.gif": 75332,
	"./images/laptop-icon.svg": 494,
	"./images/welcome-screen-microsoft.png": 9239,
	"./images/welcome-screen.png": 50311,
	"./microsoft_logo.svg": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65255;